import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import onClickFunctionKeys from '../../../utils/pagination';
import styles from './stlyes/docs-layout.module.css'

import CategoryBox from './CategoryBox';
import DocsHeader from './DocsHeader';
import DocsTable from './DocsTable';
import Pagination from '../../common/Pagination';

export default function DocsLayout({ currentId, categoryName, categoryDescription, depth, name, pagination, listResponse, listError, listLoading, downloadResponse, handleChange, changeCurrentId, hanldeDownload, handleReload }) {
    const {updateCategoryResponse, updateDocsResponse, deleteResponse} = useSelector(({ docs }) => ({
        updateCategoryResponse: docs.updateCategoryResponse,
        updateDocsResponse: docs.updateDocsResponse,
        deleteResponse: docs.deleteResponse
    }));

    // 다중 선택(다운로드, 수정, 삭제)
    const [selectedItems, setSelectedItems] = useState([]);

    // 페이지네이션
    const [pageNumbers, setPageNumbers] = useState([]);
    const [prevPageNumberLength, setPrevPageNumberLength] = useState(pageNumbers.length);

    const selectItem = (e, item) => { // selectedItems에 추가하거나 제거하는 함수
        e.stopPropagation();

        const itemKey = `${item.type}-${item.id}`;
        
        setSelectedItems((prev) => {
            const isSelected = prev.some((prevItem) => `${prevItem.type}-${prevItem.id}` === itemKey);
            
            if (isSelected) {
                return prev.filter((prevItem) => `${prevItem.type}-${prevItem.id}` !== itemKey);
            } else {
                return [...prev, item];
            }
        });
    };

    const requestPagination = (page) => {
        handleChange({ target: { name: 'page', value: page } });
    };

    const handleClickPaginationFunctionKeys = (functionKey) => {
        requestPagination(onClickFunctionKeys(functionKey, pageNumbers, pagination.currentPage));
    };

    const initializePagination = () => {
        setPrevPageNumberLength(pageNumbers.length);
        let pages = Array.from({ length: pagination.totalPages }, (_, i) => i + 1);
        setPageNumbers(pages);
    };

    useEffect(() => {
        setSelectedItems([]);
    }, [currentId, name]);

    useEffect(() => {
        setSelectedItems([]);
    }, [downloadResponse, updateCategoryResponse, updateDocsResponse, deleteResponse]);

    useEffect(() => {
        setSelectedItems([]);
    }, [pagination?.currentPage]);

    useEffect(() => {
        if (!pagination) return;
        initializePagination();
    }, [pagination]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <DocsHeader
                    depth={depth}
                    name={name}
                    handleChange={handleChange}
                />
                <CategoryBox
                    currentId={currentId}
                    categoryName={categoryName}
                    categoryDescription={categoryDescription}
                    selectedItems={selectedItems}
                    hanldeDownload={hanldeDownload}
                />
                <DocsTable
                    name={name}
                    listResponse={listResponse}
                    listError={listError}
                    listLoading={listLoading}
                    selectedItems={selectedItems}
                    setSelectedItems={setSelectedItems}
                    changeCurrentId={changeCurrentId}
                    handleReload={handleReload}
                    selectItem={selectItem}
                />
                {pagination && 
                    <Pagination
                        pageNumbers={pageNumbers}
                        prevPageNumberLength={prevPageNumberLength}
                        currentPage={pagination.currentPage}
                        handleChangePage={requestPagination}
                        handleClickFunctionKeys={handleClickPaginationFunctionKeys}
                    />
                }
            </div>
        </div>
    );
}
